export enum AmountPayType {
    BasePay = 'basePay',
    OneTime = 'oneTime',
    None = 'none'
}